import { IconInfoCircle } from '@tabler/icons-react'
import { STATUS_CONFIG, capitalizeFirstLetter, getTooltipText } from './service'
import type { Patient } from '@medplum/fhirtypes'
// TODO: Once /v2/patient/:id returns the full patient record, this hook will be the single
// source of truth for the patient and the local Medplum re-reads below can be dropped.
import { usePatient } from '@/hooks/usePatient'
import { StatusPill } from './StatusPill'
import { ResendInvitationButton } from './ResendInvitationButton'

export type UserStatus = 'invited' | 'active' | 'inactive'

type StatusBadgeProps = {
  patient: Patient
  withResendInvitationButton?: boolean
}

export function PatientActivityStatus({
  patient,
  withResendInvitationButton = false,
}: StatusBadgeProps) {
  const { data: patientData } = usePatient(patient?.id)
  const portalStatus = STATUS_CONFIG[patientData?.status ?? 'invited']

  if (!patient) return null

  return (
    <div className="text-light flex items-center gap-1">
      <StatusPill color={portalStatus.color} tooltip={getTooltipText(portalStatus.label, patient)}>
        <IconInfoCircle size={13} stroke={1.75} />
        <span>{capitalizeFirstLetter(portalStatus.label)}</span>
      </StatusPill>
      {withResendInvitationButton && <ResendInvitationButton patient={patient} />}
    </div>
  )
}
